const StringUtil = {
  /**
   * 判断空字符串
   */
  isEmptyStr: str => {
    if (str == null || str === undefined || str === '') {
      return true
    } else {
      return false
    }
  },
  /**
   * 参数：保留几位小数，货币符号，千位分隔符，小数分隔符
   */
  formatCurrency: (number, places, symbol, thousand) => {
    number = number || 0
    places = !isNaN((places = Math.abs(places))) ? places : 2
    symbol = symbol !== undefined ? symbol : '¥'
    thousand = thousand || ','
    // decimal = decimal || ".";
    const negative = number < 0 ? '-' : ''
    const i = Math.abs(+number || 0).toFixed(places) + ''
    // eslint-disable-next-line
    const j = (j = i.split('.')[0].length) > 3 ? j % 3 : 0
    const p = j ? i.substr(0, j) + thousand : ''
    const q = i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand)
    return symbol + negative + p + q
  },
  /**
   * 获取随机数
   * @param {string} urlString 位数 <Optional>
   * @returns {String}
   */
  nonceStr: a => {
    a = a || 28
    let d
    let e
    const b = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let c = ''
    for (d = 0; a > d; d += 1) {
      e = Math.random() * b.length
      e = Math.floor(e)
      c += b.charAt(e)
    }
    return c
  },
  /**
   * @returns {string}
   */
  createUniqueString: () => {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
  },
  /**
   * @param {string} input value
   * @returns {number} output value
   */
  charLength: str => {
    let len = 0
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i)
      // 单字节加1
      // eslint-disable-next-line
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
    }
    return len
  },
  /**
   * @param {string} input value
   * @returns {number} output value
   */
  byteLength: str => {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
      const code = str.charCodeAt(i)
      if (code > 0x7f && code <= 0x7ff) s++
      else if (code > 0x7ff && code <= 0xffff) s += 2
      if (code >= 0xdc00 && code <= 0xdfff) i--
    }
    return s
  },
  getRandomNum: function (length) {
    const str = "qwertyuiopasdfghjklzxcvbnm1234567890"
    const s = str.split("")
    let ret = "";
    for (let i = 0; i < length; i++) {
      ret += s[this.randomNum(1, 36)]; //生成N位的随机签名字符串
    }
    return ret;
  },
  randomNum(lbound, ubound) {
    return (Math.floor(Math.random() * (ubound - lbound)) + lbound)
  },
  /**
   * 自定义函数名：PrefixZero
   * @param num： 被操作数
   * @param n： 固定的总位数
   */
  prefixZero(num, n) {
    return (Array(n).join(0) + num).slice(-n)
  }
}

export { StringUtil }
